import { IUpdateAtributosSistemaUseCase } from "../../../presentation/useCases/update/update_atributos_sistema_use_case";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * UpdateAtributosSistemaUseCase
 */

export class UpdateAtributosSistemaUseCase implements IUpdateAtributosSistemaUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(
    idAtributoSistema: number,
    limparArquivo: boolean,
    nomeCliente?: string,
    logoCliente?: string,
    extensaoLogo?: string,
  ): Promise<void> {
    await this.repository.updateAtributoSistema(
      idAtributoSistema,
      limparArquivo,
      nomeCliente,
      logoCliente,
      extensaoLogo
    );
  }
}